<template>
    <section class="layout layout-scale">
        <QuizHeader :title="stripHtmlTag(title)" :currentQuizIndex="currentQuizIndex" :questionCount="questionCount" />
        <bg-music-mute-btn
            v-if="playerSound.effectMusic && question.question_type !== 'video' && question.question_type !== 'music'"
            class="pr-4"
            :is-muted="isMuted"
        ></bg-music-mute-btn>
        <count-down @handleClickNext="handleClickNext" />
    </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import popup from '@/lib/popup.js'
import UserService from '@/lib/user.js'
import Request from '@/lib/request.js'
import CountDown from '@/components/CountDown'
import appConfig from '@/app.config.js'
import QuizHeader from '@/components/QuizHeader.vue'
import BgMusicMuteBtn from '@/components/BgMusicMuteBtn.vue'
import helperMixins from '@/mixins/helper.js'
import socketConnectionMixin from '@/mixins/socket-connection.js'
import { playerSocketSetting } from '@/mixins/live-quiz-socket.js'

export default {
    components: {
        CountDown,
        QuizHeader,
        BgMusicMuteBtn
    },

    mixins: [helperMixins, socketConnectionMixin],

    mounted: function () {
        const user = new UserService()
        if (user.getUser()) {
            const request = new Request(),
                userPlayer = user.getUser(),
                payload = {
                    user_activity: 'last_play'
                }

            request.post(appConfig.api.setLastActivity.replace(/__id__/, userPlayer.id), payload)
        }

        window.onbeforeunload = function () {
            return 'Are you sure you want to leave this page? You will loose any unsaved actions'
        }

        window.addEventListener('unload', this.handleUserCloseWindow)

        this.checkCurrentGame()

        if (this.audioSpotify) {
            this.audioSpotify.setAttribute('src', null)
        }
    },

    destroyed() {
        window.onbeforeunload = function () {}
    },

    sockets: {
        no_user_in_room: function () {},

        master_pressed_end: function () {
            let txtType =
                this.type === 'poll'
                    ? this.firstUppercase(this.$t('playlive_share_type_poll'))
                    : this.firstUppercase(this.$t('playlive_share_type_quiz'))

            popup.alert(
                this.$t('playlive_alert_done', { type: txtType }),
                function () {
                    this.$router.replace({
                        name: 'summary'
                    })
                }.bind(this)
            )
        },

        master_pressed_next: function () {
            this.$store.dispatch('player/handleNextQuestionIndex')
            this.$router.push({
                name: 'redirect-quiz',
                params: {
                    code: this.code
                }
            })
        },

        continue_game_joined: function (data) {
            const currentIndex = this.currentQuizIndex
            let txtDone =
                this.type === 'poll'
                    ? this.firstUppercase(this.$t('playlive_share_type_poll'))
                    : this.firstUppercase(this.$t('playlive_share_type_quiz'))
            let txtCancelled =
                this.type === 'poll' ? this.$t('playlive_share_type_poll') : this.$t('playlive_share_type_quiz')

            if (currentIndex !== data.index && data.index > -1 && data.index != null) {
                popup.alert(
                    this.$t('playlive_alert_timeup'),
                    function () {
                        this.$store.commit('player/updateCurrentQuizIndex', data.index)

                        this.$router.push({
                            name: 'redirect-quiz',
                            params: {
                                code: this.$route.params.code
                            }
                        })
                    }.bind(this)
                )
            }

            if (data.index === -1) {
                popup.alert(
                    this.$t('playlive_alert_done', { type: txtDone }),
                    function () {
                        this.$router.replace({
                            name: 'summary'
                        })
                    }.bind(this)
                )
            }

            if (data.index == null) {
                popup.alert(this.$t('playlive_alert_cancelled', { type: txtCancelled }), function () {
                    window.location.href = '/join'
                })
            }
        },

        ...playerSocketSetting
    },

    methods: {
        handleUserCloseWindow: function () {
            this.$store.dispatch('player/emitUserEndGameToSocket', {
                room: this.code,
                name: this.name,
                socket: this.$socket
            })
        },

        handleClickNext: function () {
            if (this.$route.params.name) {
                this.$router.push({
                    name: 'quiz',
                    params: {
                        code: this.$route.params.code
                    }
                })
            } else {
                this.$router.replace({
                    name: 'quiz',
                    params: {
                        code: this.$route.params.code
                    }
                })
            }
        },

        checkCurrentGame: function () {
            this.$socket.emit('check_game_index', {
                room: this.code
            })
        }
    },

    computed: {
        ...mapGetters({
            question: 'player/getCurrentQuiz',
            questionCount: 'player/getQuestionCount',
            audioPlucky: 'getPluckyAudio',
            playerSound: 'player/getPlayerSound',
            audioSpotify: 'getSpotifyAudio'
        }),

        ...mapState({
            name: state => state.player.name,
            code: state => state.player.quiz.code,
            type: state => state.player.quiz.type,
            title: state => state.player.quiz.title,
            currentQuizIndex: state => state.player.currentQuizIndex,
            isMuted: state => state.isMuted
        })
    },

    beforeRouteLeave(to, from, next) {
        let self = this

        window.onbeforeunload = function () {}

        if (to.name === 'quiz' || to.name === 'summary') {
            next()
        } else {
            next(false)
            popup.confirm(
                this.$t('playlive_alert_leave'),
                function () {
                    this.$store.dispatch('player/emitUserEndGameToSocket', {
                        room: self.code,
                        name: self.name,
                        socket: self.$socket
                    })

                    window.location.href = '/join'

                    // next()
                },
                function () {
                    window.onbeforeunload = function () {
                        return 'Are you sure you want to leave this page? You will loose any unsaved actions'
                    }
                }
            )
        }
    }
}
</script>

<style lang="scss" scoped>
.layout {
    margin-top: -1rem;
    margin-right: -1rem;
    margin-left: -1rem;

    .content {
        padding-left: 1rem;
        padding-right: 1rem;
    }
}
</style>
